import useClearAllSmartviews from 'components/generic/smartview/shared/hooks/useClearAllSmartviews';
import SmartviewSideDrawer from 'components/generic/smartview/smartviewSideDrawer/SmartviewSideDrawer';
import useFilters from '../../shared/hooks/useFilters';

export default function FilterSmartViewDrawer() {
    const clearAll = useClearAllSmartviews();
    const { applyPendingFilters } = useFilters();

    return (
        <SmartviewSideDrawer
            overlayProps={{
                onClick: () => {
                    applyPendingFilters();
                    clearAll();
                }
            }}
        />
    );
}
